import { render, staticRenderFns } from "./BasicInformation.vue?vue&type=template&id=a17a0816&"
import script from "./BasicInformation.vue?vue&type=script&lang=js&"
export * from "./BasicInformation.vue?vue&type=script&lang=js&"
import style0 from "./BasicInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a17a0816')) {
      api.createRecord('a17a0816', component.options)
    } else {
      api.reload('a17a0816', component.options)
    }
    module.hot.accept("./BasicInformation.vue?vue&type=template&id=a17a0816&", function () {
      api.rerender('a17a0816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/candidates/basic-information/BasicInformation.vue"
export default component.exports